import { useEffect, useRef, useState } from 'react';

const links = [
  { id: 'pod-bristol', label: 'Pod Bristol' },
  { id: 'about', label: 'About' },
  { id: 'projects', label: 'Projects' },
  { id: 'contact', label: 'Contact' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const ticking = useRef(false);

  useEffect(() => {
    const onScroll = () => {
      if (ticking.current) return;
      ticking.current = true;
      requestAnimationFrame(() => {
        setScrolled(window.scrollY > 40);
        ticking.current = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'py-3 backdrop-blur-md bg-[#F9F8F6]/80 border-b border-line' : 'py-6'
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="group flex items-baseline gap-2 text-ink"
        >
          <span className="font-display text-2xl md:text-3xl leading-none tracking-tight">
            Joanna<span className="italic"> Bedevian</span>
          </span>
          <span className="hidden md:inline text-[10px] tracking-[0.3em] uppercase text-sub mt-1">Interior Designer</span>
        </button>

        {/* Desktop links */}
        <ul className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-${l.id}`}
                onClick={() => go(l.id)}
                className="hover-underline text-[11px] tracking-[0.28em] uppercase text-ink/85 hover:text-ink"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="cta-talk"
          onClick={() => go('contact')}
          className="hidden md:inline-flex btn-ghost"
        >
          Let’s Talk <span aria-hidden>→</span>
        </button>

        {/* Mobile toggle */}
        <button
          data-testid="mobile-menu-toggle"
          aria-label="Open menu"
          className="md:hidden inline-flex flex-col gap-1.5 p-2"
          onClick={() => setOpen((v) => !v)}
        >
          <span className={`block h-px w-6 bg-ink transition-transform ${open ? 'translate-y-[7px] rotate-45' : ''}`} />
          <span className={`block h-px w-6 bg-ink transition-opacity ${open ? 'opacity-0' : 'opacity-100'}`} />
          <span className={`block h-px w-6 bg-ink transition-transform ${open ? '-translate-y-[7px] -rotate-45' : ''}`} />
        </button>
      </div>

      {/* Mobile drawer */}
      <div
        className={`md:hidden overflow-hidden transition-[max-height] duration-500 ${
          open ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className="px-6 py-6 bg-bg border-t border-line">
          <ul className="flex flex-col gap-5">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`mnav-${l.id}`}
                  onClick={() => go(l.id)}
                  className="font-display text-3xl tracking-tight text-ink"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
